import { type NextPage } from 'next'
import dynamic from 'next/dynamic'
import React from 'react'
import { type DevUtils } from '@dustin-web/microsite-components/src/dev/dev-admin'
import { type BaseLayoutInputConfig } from '@dustin-web/microsite-config'
import Root from '@dustin-web/microsite-baselayout/src/components/root'
import { useRouter } from 'next/router'

const BaseLayout = dynamic(() => import('@dustin-web/microsite-baselayout'))

export function withMicrositeWrapper<WrappedProps = object, WrappedInternalProps = WrappedProps>(
  WrappedComponent: NextPage<WrappedProps, WrappedInternalProps>,
  config?: BaseLayoutInputConfig
) {
  const WithServerData = ({ ...pageProps }: any & { devUtils: DevUtils }) => {
    const { query } = useRouter()

    return (
      <Root {...pageProps} query={query} apolloState={{}}>
        {(config?.useDefaultBaseLayout ?? true) ? (
          <BaseLayout
            showHeader={config?.showHeader ?? true}
            page={config?.page}
            devUtils={pageProps.devUtils}>
            <WrappedComponent {...(pageProps as any)} />
          </BaseLayout>
        ) : (
          <WrappedComponent {...(pageProps as any)} />
        )}
      </Root>
    )
  }

  if (process.env.NODE_ENV !== 'production') {
    const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component'

    WithServerData.displayName = `withMicrositeWrapper(${displayName})`
  }

  return WithServerData
}
